export const BUILD_INFO = { sha: 'aad3021' };
